import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import PropTypes from 'prop-types';
import { remapHoverProps } from '../focus';
import { useThemeDefaults } from '../utils';
import Text from '../Text';
import { buttonBase, InteractiveText } from './base';

var standard = function standard(props) {
  return {
    bg: props.theme.colors.bg,
    color: props.theme.colors.ctrl,
    hoverColor: props.theme.colors.ctrlHover
  };
};

var standardPrimary = function standardPrimary(props) {
  return {
    bg: props.theme.colors.ctrl,
    hoverBg: props.theme.colors.ctrlHover,
    borderColor: props.theme.colors.ctrl,
    color: props.theme.colors.bg
  };
};

var destructive = function destructive(props) {
  return {
    bg: props.theme.colors.bg,
    color: props.theme.colors.error,
    hoverColor: props.theme.colors.errorHover
  };
};

var destructivePrimary = function destructivePrimary(props) {
  return {
    color: props.theme.colors.bg,
    bg: props.theme.colors.error,
    hoverBg: props.theme.colors.errorHover,
    borderColor: props.theme.colors.error
  };
};

var disabled = function disabled(props) {
  return {
    bg: props.theme.colors.bg,
    color: props.theme.colors.ctrlDisabled,
    cursor: 'default'
  };
};

var disabledPrimary = function disabledPrimary(props) {
  return {
    color: props.theme.colors.bg,
    bg: props.theme.colors.ctrlDisabled,
    borderColor: props.theme.colors.ctrlDisabled,
    cursor: 'default'
  };
};

export var buttonVariants = function buttonVariants(props) {
  var base = buttonBase(props);

  if (props.variant === 'disabled' || props.disabled) {
    return props.primary ? _objectSpread(_objectSpread({}, base), disabledPrimary(props)) : _objectSpread(_objectSpread({}, base), disabled(props));
  }

  if (props.variant === 'destructive') {
    return props.primary ? _objectSpread(_objectSpread({}, base), destructivePrimary(props)) : _objectSpread(_objectSpread({}, base), destructive(props));
  }

  return props.primary ? _objectSpread(_objectSpread({}, base), standardPrimary(props)) : _objectSpread(_objectSpread({}, base), standard(props));
};
var Button = useThemeDefaults(function (props) {
  return _objectSpread({
    as: 'button',
    cursor: 'pointer'
  }, buttonVariants(props));
}, InteractiveText);
Button.propTypes = _objectSpread(_objectSpread(_objectSpread({}, Text.propTypes), remapHoverProps.propTypes), {}, {
  variant: PropTypes.oneOf(['standard', 'destructive', 'disabled']),
  large: PropTypes.bool,
  primary: PropTypes.bool
});
export default Button;